import { useForm, FieldErrors, UseFormRegister } from 'react-hook-form';

export type SmilesForm = {
  clientNumber: string;
};

export type SmilesData = {
  register: UseFormRegister<SmilesForm>;
  errors: FieldErrors<SmilesData>;
  getValue: () => SmilesForm | undefined;
};

export function useSmiles() {
  const {
    register,
    formState: { errors },
    reset,
    getValues,
    trigger,
  } = useForm<SmilesForm>({ mode: 'onBlur' });

  const smilesData: SmilesData = {
    register: register,
    errors: errors,
    getValue: getValues,
  };

  return [smilesData, trigger, reset] as const;
}
